



























































import { Component, Vue } from "vue-property-decorator";
import { Image as VanImage, Icon, Checkbox, CheckboxGroup } from "vant";
import request from "@/api/index";
import { IHosts } from "@/api/types";
import { toastWithDelay } from "@/common/decorator";

@Component({
  components: { VanImage, Icon, Checkbox, CheckboxGroup }
})
export default class HostFilter extends Vue {
  // 全部选择checkbox
  all = false;
  // 主持人列表checkbox
  hostCheck: IHosts["data"] = [];
  show = false;
  hostList: IHosts["data"] = [];

  mounted() {
    this.getHostList();
  }

  // 获取主持人列表
  @toastWithDelay({
    message: "加载中...",
    forbidClick: true,
    overlay: true
  })
  async getHostList() {
    const res = await request.getHosts(
      this.$route.query.id || this.$store.state.infoClassifyId
    );
    if (res.code === 0) {
      this.hostList = res.data;
      // 回显 暂时不做
      // if (this.$route.query.hostIds) {
      //   const checkedIds: string[] = (this.$route.query.hostIds as string).split(",");
      //   this.hostCheck = this.hostList.filter(host =>
      //     checkedIds.includes(String(host.id))
      //   );
      // }
    }
  }

  // 点击全部
  chooseAll() {
    this.all = !this.all;
    (this.$refs.checkboxGroup as CheckboxGroup).toggleAll(this.all);
  }

  // 主持人列表变化
  onHostChange(host: boolean[]) {
    if (host.length < this.hostList.length) {
      this.all = false;
    }
  }

  // 点击确认
  onConfirm() {
    // 默认都不选就是全选
    this.$store.commit("SET_STATE", {
      checkedHosts: this.all ? [] : this.hostCheck.map(host => host.id)
    });
    console.log(
      "选择主持人id：",
      this.all ? [] : this.hostCheck.map(host => host.id)
    );
    this.$router.back();
  }
  // 点击重置
  onReset() {
    this.all = false;
    (this.$refs.checkboxGroup as CheckboxGroup).toggleAll(false);
  }
}
